import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { colors, type, spacing } from "@/theme";
import { api } from "@/lib/api";

export default function TenantPrivacy() {
  const navigate = useNavigate();
  const { slug } = useParams();
  const [data, setData] = useState(null);

  useEffect(() => {
    api.getPrivacy(slug).then(setData).catch(() => setData({ nome: "", privacy: "Informativa non disponibile." }));
  }, [slug]);

  return (
    <div style={{ minHeight: "100vh", background: colors.bg }}>
      <div style={{ maxWidth: 480, margin: "0 auto" }}>
        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: `${spacing.md}px ${spacing.lg}px` }}>
          <button data-testid="back-button" onClick={() => navigate(-1)} style={{ background: "none", border: "none", display: "flex", padding: 0 }}><ChevronLeft size={26} color={colors.ink} /></button>
          <div style={{ ...type.serif, fontSize: 22, color: colors.ink }}>Privacy</div>
          <div style={{ width: 26 }} />
        </div>
        {!data ? <div style={{ textAlign: "center", padding: spacing.xl, ...type.sans, color: colors.accent }}>Caricamento…</div> : (
          <div style={{ padding: spacing.lg }}>
            {data.nome ? <div style={{ ...type.sansSemi, fontSize: 15, color: colors.accent, marginBottom: spacing.md }}>{data.nome}</div> : null}
            <div data-testid="privacy-text" style={{ ...type.sans, fontSize: 15, color: colors.ink, lineHeight: "24px", whiteSpace: "pre-wrap" }}>{data.privacy}</div>
          </div>
        )}
      </div>
    </div>
  );
}
